import { Button, List, Modal } from "antd";
import { useContext, useEffect, useState } from "react";
import useWsSender from "lib/wsSenderHook";
import { showToast } from "ui/components/common";
import { SignalContext } from "context/SignalContext";
import { safeParseJSON } from "lib/utils";
export default function ({ deviceId, orgId }) {
  const [modalShow, setModalShow] = useState(false);
  const [waitingId, setWaitingId] = useState("");
  const { sendWsRequest } = useWsSender();
  const [listData, setListData] = useState([]);
  const { wsMsgData } = useContext(SignalContext);
  const refreshUpgradeStatus = async () => {
    const res: any = await sendWsRequest(
      "device.camera.upgradable",
      {
        cameraUpgradable: {
          deviceId,
        },
      },
      { orgId },
    );
    setListData(res.cameraUpgradableReply.Cameras);
  };
  useEffect(() => {
    if (!modalShow) return;
    refreshUpgradeStatus();
  }, [modalShow]);
  const upgradeCameras = async () => {
    try {
      const res: any = await sendWsRequest(
        "device.camera.upgrade",
        {
          cameraUpgrade: {
            deviceId,
          },
        },
        { orgId },
      );
      const msg = res?.cameraUpgradeReply;
      if (msg?.done) {
        if (msg.exitCode !== 0) {
          showToast(1, msg.output);
        } else {
          showToast(0, "Task done");
        }
        setWaitingId("");
        refreshUpgradeStatus();
      } else {
        setWaitingId(res.__wsRequestId);
        showToast(0, "Forward success upgrading...");
      }
    } catch (e) {
      console.error(e);
      const error = safeParseJSON(e.message);
      if (error?.message) {
        showToast(1, error?.message);
      } else {
        showToast(1, "Forward failed");
      }
    }
  };
  useEffect(() => {
    if (waitingId && wsMsgData && wsMsgData.result?.id === waitingId) {
      const msg = wsMsgData.result?.data?.cameraUpgradeReply;
      if (msg?.done) {
        if (msg.exitCode !== 0) {
          showToast(1, msg.output);
        } else {
          showToast(0, "Task done");
        }
        setWaitingId("");
        refreshUpgradeStatus();
      }
    }
  }, [wsMsgData, waitingId]);
  return (
    <>
      <Button onClick={() => setModalShow(true)} type="link">
        Upgrade Cameras
      </Button>
      <Modal
        title={"Upgrade Cameras"}
        open={modalShow}
        okText={"Upgrade"}
        okButtonProps={{ className: "primaryButton" }}
        cancelButtonProps={{ className: "primaryButton bordered" }}
        onCancel={() => setModalShow(false)}
        onOk={upgradeCameras}
      >
        <List
          itemLayout="horizontal"
          dataSource={listData}
          renderItem={(item, index) => (
            <List.Item>
              <List.Item.Meta
                title={<a>{item.Name}</a>}
                description={`FirmwareVersion: ${item.FirmwareVersion}, upgradable to ${item.HasNewVersion ? `newFirmwareVersion:${item.NewFirmwareVersion}` : "-"} `}
              />
            </List.Item>
          )}
        />
      </Modal>
    </>
  );
}
